import React from "react";

import {
  AssignmentInd,
  Business,
  ContactPage,
  Email,
  InfoOutlined,
  PeopleAltOutlined,
  Person,
  Phone,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

import { useCustomerDetailContext } from "contexts/CustomerDetailContext";

import Status from "components/Shared/Status";

const CustomerBasicDetail = () => {
  const { customerDetail, loadingCustomer } = useCustomerDetailContext();
  return !loadingCustomer ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <PeopleAltOutlined color="primary" />}
            title="Customer ID"
            subtitle={customerDetail?.customerID}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Name"
            subtitle={customerDetail?.name}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <Business color="primary" />}
            title="Customer Type"
            subtitle={customerDetail?.customerType || "Individual"}
          />
        </Grid>

        {customerDetail?.customerType === "Business" && (
          <Grid item xs={4}>
            <InformationTile
              icon={() => <Business color="primary" />}
              title="Organization Name"
              subtitle={customerDetail?.organizationName || "N/A"}
            />
          </Grid>
        )}

        <Grid item xs={4}>
          <InformationTile
            icon={() => <Email color="primary" />}
            title="Email"
            subtitle={customerDetail?.email}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <Phone color="primary" />}
            title="Phone"
            subtitle={customerDetail?.phone}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <ContactPage color="primary" />}
            title="Address"
            subtitle={customerDetail?.address}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AssignmentInd color="primary" />}
            title="VAT / PAN No"
            subtitle={customerDetail?.vatPanNo || "N/A"}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={customerDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default CustomerBasicDetail;
